import { MenuItem, Select, TextField } from "@mui/material"
import { useMutation, useQuery } from "@tanstack/react-query";
import { Field, Formik, Form, FormikValues } from "formik"
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import CustomButtonSimple from "../../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { buildEndpoint, fetchDesenhosRelatorioControlo, genericFileUpload, genericPost } from "../../../../../services/api.service";
import { IPecaParaEntrega } from "../../../../Obras/newObra/IObra"
import { FileUploader } from "../../../../../components/FileUploader";
import AttachmentIcon from '@mui/icons-material/Attachment';
import { hasError } from "../../../../../components/FormComponents/utils";
import { AplicadorDeCotas } from "./AplicadorDeCotas";
import axios from "axios";
import { RelatorioControlo } from "../../../../../types";





export function ControloEQualidadeForm({ relatorioControlo, pecaEntrega, relatoriControloState, fetchRelatorio, closeForm }: { relatorioControlo?: RelatorioControlo, pecaEntrega: IPecaParaEntrega, relatoriControloState: {hasChanges: any, setHasChanges: any}, fetchRelatorio: any, closeForm: ()=> void }) {

    const [editable, setEditable] = useState(!pecaEntrega.controloQualidade);
    const anexosFormRef = useRef<any>(null);


    

    const { data: anexo } = useQuery<any>({
        queryKey: ['orcamentos', relatorioControlo?.id],
        queryFn: async () => {
            if (relatorioControlo)
                return await fetchDesenhosRelatorioControlo(relatorioControlo.id);
        },
    })

    const anexosMutation = useMutation(genericFileUpload(`/relatorios-controlo/${pecaEntrega.id}/anexos/upload`), {
        onSuccess: (data: any) => {
            toast.success("Anexos adicionados com sucesso!");
            anexosFormRef.current.resetForm();
            fetchRelatorio();
        },
        onError: (error) => {
            console.log("Error on upload!")
        }
    })




    return (<div className="z-[1000] bg-white opacity-100 max-h-full overflow-y-auto">
       
                <Formik
                    initialValues={{
                        anexos: []
                    }}
                    onSubmit={async (values: FormikValues) => {
                        const documentToSave = new FormData();
                        values.anexos.map((dt: File) => {
                            documentToSave.append('anexos', dt);
                        })
                        anexosMutation.mutate(documentToSave);
                    }}
                    innerRef={anexosFormRef}

                >
                    {(props) => {
                        const { values, errors, touched, handleChange, setFieldValue } = props;
                        console.log("Values: ", values);
                        return (
                            <Form>
                                {!anexo ?
                                    <div className="p-5 flex flex-col w-2/3">
                                        <div className="text-lg font-bold mb-2">Desenhos para numeração de cotas</div>
                                        <Field
                                            className={"w-1/6"}
                                            name={`anexos`}
                                            component={FileUploader}
                                            title={"Carregua desenhos (PDF)"}
                                            type={"number"}
                                            size="small"
                                            icon={<AttachmentIcon style={{ fontSize: '2.5em' }} />}
                                            error={hasError({ errors, touched, name: `anexos` as any })}
                                            variant={'outlined'}
                                            label={'Introduza o PDF dos desenhos para numeração de cotas'} />
                                            
                                            <CustomButtonSimple className="mt-2" disabled={!values.anexos.length}  type="submit" text="Submeter desenhos"/>
                                        {/* <button disabled={!values.anexos} className="bg-rodrimaq-red text-white p-3 rounded border border-rodrimaq-red hover_bg-white hover:text-rodrimaq-red cursor-pointer mt-3">
                                            Submeter desenhos
                                        </button> */}
                                    </div>
                                    : null}

                                {
                                    anexo && relatorioControlo ?
                                        <AplicadorDeCotas
                                        relatorioControloState={relatoriControloState}
                                        relatorioControlo={relatorioControlo} pecaEntrega={pecaEntrega} desenho={anexo.data}
                                        closeForm={closeForm}
                                        />
                                        : null
                                }

                            </Form>
                        )

                    }
                    }


                </Formik>
      

    </div>
    )



}